<template>
  <v-card outlined tile class="ma-3 pa-0 align-start">
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Наименование</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="GOST_NAME" dense :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Код</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="GOST_CODE" dense :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Тип топлива</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <ws-type-selector :set-global-filter="false" v-model="FT" :readonly="mode=='viewer'" :hide-all-options="true"></ws-type-selector>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>

import WsTypeSelector from '@/components/modules/projects/ui/wsTypeSelector'
import { RCPT_GET_RCPT_TYPES_LIST } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'refGOST2FtCard',
  components: { WsTypeSelector },
  props: ['GOST', 'mode'],
  data () {
    return {
    }
  },
  computed: {
    GOST_NAME: {
      get () {
        console.log('requested GOST_NAME from refGOST2FTCard, GOST is ', this.GOST)
        return this.GOST ? this.GOST.GOST_NAME : ''
      },
      set (val) {
        this.$emit('onGOSTUpdate', { GOST_NAME: val })
      }
    },
    GOST_CODE: {
      get: function () {
        return this.GOST ? this.GOST.GOST_CODE : ''
      },
      set (val) {
        this.$emit('onGOSTUpdate', { GOST_CODE: val })
      }
    },
    FT: {
      get: function () {
        return this.GOST ? this.GOST.FT ? this.GOST.FT.FT_ID : null : null
      },
      set (val) {
        if (!val) {
          this.$emit('onGOSTUpdate', null)
        }
        this.$emit('onGOSTUpdate', { FT: { FT_ID: val, FT_NAME: this.getFTName(val) } })
      }
    }
  },
  methods: {
    getFTName (FT_ID) {
      const names = this.$store.getters.getRecepturesTypesList
      const self = this
      if (names.length) {
        const ft = names.find(itm => itm.FT_ID === FT_ID)
        return ft ? ft.FT_NAME : 'нет'
      } else {
        this.$store.dispatch(RCPT_GET_RCPT_TYPES_LIST)
          .then((resp) => {
            if (resp.data.data) {
              const ft = resp.data.data.find(itm => itm.FT_ID === FT_ID)
              return ft ? ft.FT_NAME : 'нет'
            } else {
              self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка типов рецептур: \n ${resp.data.error_text}` })
            }
          })
          .catch((err) => {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка типов рецептур: \n ${err}` })
          })
      }
    },
    setFT (val) {
      console.log('Setting FT to ', val)
      this.FT = val
    }
  },
  mounted () {
    console.log('refGOST2FTCard mounted in mode ', this.mode, ' with GOST ', this.GOST)
  }
}
</script>
